module.exports = __webpack_public_path__ + "img/lion.d68c0f31.jpeg";